module.exports = __webpack_public_path__ + "media/dashboard/assets/images/robot-30f8c0c82b8e3e098bb718a84ad510f2.png";